import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaCamera,
  FaEnvelope,
  FaFileContract,
  FaShieldAlt,
  FaUsers,
} from 'react-icons/fa';
import './FooterPage.css';

const pageContent = {
  about: {
    icon: <FaUsers />,
    title: 'A propos de PhotoMatch',
    eyebrow: 'Notre mission',
    intro:
      "PhotoMatch aide les participants a retrouver leurs photos d'evenements et donne aux photographes un espace clair pour organiser, partager et vendre leur travail.",
    sections: [
      {
        title: 'Pour les participants',
        body:
          "Un profil, une photo de reference et une galerie plus facile a explorer. Les souvenirs importants deviennent rapides a retrouver.",
      },
      {
        title: 'Pour les photographes',
        body:
          "Des evenements centralises, une distribution simplifiee et des outils pour suivre les galeries, les achats et l'activite.",
      },
      {
        title: 'Une experience simple',
        body:
          "L'application reste concentree sur les taches essentielles: importer, rechercher, consulter, acheter et livrer les photos.",
      },
    ],
  },
  contact: {
    icon: <FaEnvelope />,
    title: 'Contact',
    eyebrow: 'Nous joindre',
    intro:
      "Une question sur un evenement, un compte photographe ou un forfait PhotoMatch ? Envoyez-nous un message et notre equipe vous repondra.",
    sections: [
      {
        title: 'Support',
        body: 'support@photomatch.com',
      },
      {
        title: 'Ventes',
        body: 'sales@photomatch.com',
      },
      {
        title: 'Delai de reponse',
        body:
          'Nous traitons les demandes en priorite pendant les jours ouvrables.',
      },
    ],
  },
  privacy: {
    icon: <FaShieldAlt />,
    title: 'Politique de confidentialite',
    eyebrow: 'Vos donnees',
    intro:
      'PhotoMatch est concu pour limiter les donnees aux informations necessaires au fonctionnement du service et a la recherche de photos.',
    sections: [
      {
        title: 'Informations de compte',
        body:
          'Nous utilisons les informations de profil pour authentifier les utilisateurs, personnaliser les espaces et gerer les galeries.',
      },
      {
        title: 'Photos et correspondances',
        body:
          "Les photos importees servent a organiser les evenements et a proposer des resultats de recherche pertinents aux personnes autorisees.",
      },
      {
        title: 'Controle',
        body:
          "Les utilisateurs peuvent mettre a jour leur profil et demander de l'aide pour les questions liees aux donnees.",
      },
    ],
  },
  terms: {
    icon: <FaFileContract />,
    title: "Conditions d'utilisation",
    eyebrow: 'Cadre du service',
    intro:
      "En utilisant PhotoMatch, vous acceptez de respecter les comptes, les evenements et les contenus partages sur la plateforme.",
    sections: [
      {
        title: 'Utilisation responsable',
        body:
          "Importez uniquement les photos et informations que vous etes autorise a utiliser dans le cadre de vos evenements.",
      },
      {
        title: 'Comptes',
        body:
          'Chaque utilisateur est responsable de la securite de son compte et de l exactitude des informations fournies.',
      },
      {
        title: 'Paiements',
        body:
          'Les achats, forfaits et livraisons numeriques sont geres selon les options affichees au moment de la commande.',
      },
    ],
  },
};

const FooterPage = ({ type }) => {
  const content = pageContent[type] || pageContent.about;

  return (
    <div className="footer-page">
      <section className="footer-page-hero">
        <div className="footer-page-icon">{content.icon || <FaCamera />}</div>
        <p>{content.eyebrow}</p>
        <h1>{content.title}</h1>
        <span>{content.intro}</span>
      </section>

      <section className="footer-page-content">
        {content.sections.map((section) => (
          <article className="footer-info-card" key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </article>
        ))}
      </section>

      <div className="footer-page-action">
        <Link to="/" className="footer-page-button">
          Retour a l'accueil
        </Link>
      </div>
    </div>
  );
};

export default FooterPage;
